import { useLocation } from 'react-router-dom';
import { useSyncExternalStore } from 'react';
import SkeletonPulse from './SkeletonPulse';
import { getTranscriptTitleFromUrl } from '@/components/molecules/Transcript/utils';
import featureFlagStore from '@/stores/featureFlagStore';
import { FeatureFlagKeys } from '@/services/featureFlag';

const TranscriptTextSkeleton = () => {
  return (
    <div role="status" className="max-w-full animate-pulse px-6">
      <SkeletonPulse classname="mb-4 h-2.5 w-48 rounded-sm " />
      <SkeletonPulse classname="mb-2.5 h-3 max-w-[360px] rounded-sm " />
      <SkeletonPulse classname="mb-2.5 h-3 rounded-sm " />
      <SkeletonPulse classname="mb-2.5 h-3 max-w-[330px] rounded-sm " />
      <SkeletonPulse classname="mb-2.5 h-3 max-w-[300px] rounded-sm " />
      <SkeletonPulse classname="mb-3 h-3 max-w-[360px] rounded-sm " />
      <SkeletonPulse classname="mb-2.5 h-3 rounded-sm " />
      <SkeletonPulse classname="mb-2.5 h-3 max-w-[330px] rounded-sm " />
      <SkeletonPulse classname="mb-2.5 h-3 max-w-[300px] rounded-sm " />
      <SkeletonPulse classname="mb-2.5 h-3 max-w-[360px] rounded-sm " />
      <SkeletonPulse classname="mb-2.5 h-3 rounded-sm " />
      <SkeletonPulse classname="mb-2.5 h-3 max-w-[330px] rounded-sm " />
      <SkeletonPulse classname="mb-2.5 h-3 max-w-[300px] rounded-sm " />
      <SkeletonPulse classname="mb-3 h-3 max-w-[360px] rounded-sm " />
      <SkeletonPulse classname="mb-2.5 h-3 rounded-sm " />
      <SkeletonPulse classname="mb-2.5 h-3 max-w-[330px] rounded-sm " />
    </div>
  );
};

const TranscriptSkeletonContainer = () => {
  const location = useLocation();
  const featureFlags = useSyncExternalStore(featureFlagStore.subscribe, featureFlagStore.getSnapshot) ?? {};
  const isClipDuplicationEnabled = !!featureFlags[FeatureFlagKeys.Use_CL_Clip_Duplication];
  const isRecordingsPage = location.pathname.includes('/recordings');

  const transcriptTitle = getTranscriptTitleFromUrl({
    search: location.search,
    isClipDuplicationEnabled,
    isRecordingsPage
  });

  return (
    <div className="size-full overflow-hidden rounded-lg bg-white">
      <div className="flex h-14 items-center justify-between px-5 shadow-lg shadow-slate-900/[0.075]">
        <div className="select-none text-lg font-medium leading-tight">{transcriptTitle}</div>
        <div className="flex gap-2">
          <SkeletonPulse classname="size-6 rounded-md" />
          <SkeletonPulse classname="size-6 rounded-md" />
        </div>
      </div>
      <div className="pt-2">
        <TranscriptTextSkeleton />
        <TranscriptTextSkeleton />
      </div>
    </div>
  );
};

export default TranscriptSkeletonContainer;
